import gql from 'graphql-tag'

export const GET_PROJECT_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getProjectPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleKg
        titleRu
        type
      }
    }
  }
`

export const GET_PROJECT_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProject (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleKg
      titleRu
      descriptionEn
      descriptionKg
      descriptionRu
      image
      type
      url
    }
  }
`
